import { render, staticRenderFns } from "./ListFaq.vue?vue&type=template&id=599c285c&scoped=true&"
import script from "./ListFaq.vue?vue&type=script&lang=js&"
export * from "./ListFaq.vue?vue&type=script&lang=js&"
import style0 from "./ListFaq.vue?vue&type=style&index=0&id=599c285c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599c285c",
  null
  
)

export default component.exports